import { render, staticRenderFns } from "./c-rent-list.vue?vue&type=template&id=879ad6e4&scoped=true"
import script from "./c-rent-list.vue?vue&type=script&lang=js"
export * from "./c-rent-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879ad6e4",
  null
  
)

export default component.exports